import { Base, createApp } from '@studiometa/js-toolkit';
import 'liquid-ajax-cart';
import Shop from './components/Shop/index.js';
import Sections from './components/Sections/index.js';

/**
 * App
 */
class App extends Base {
  /**
   * App Configuration
   */
  static config = {
    name: 'App',
    components: {
      Shop,
      Sections,
    },
  };
}

export default createApp(App, {
  root: document.documentElement,
  // `breakpoints` et non `screens` : js-toolkit ignore toute autre clé, et
  // retombait donc sur ses propres valeurs par défaut — des noms (`xxs`, `xxl`)
  // et des seuils (`s` à 768px) qui ne correspondaient pas à ceux du CSS.
  breakpoints: {
    '2xs': '0rem',
    xs: '30rem',
    s: '40rem',
    m: '48rem',
    l: '64rem',
    xl: '80rem',
    '2xl': '96rem',
    '3xl': '120rem',
  },
});
